import moment from 'moment';
import { store } from 'redux/store';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

const assignedAndSyncedChecksManipulationJson = ({ checkCache, syncCheckCache, initialLogin }) => {
  const { checks } = store.getState();

  const allChecksMap =
    _.size(checks?.checksList) > 0 && !initialLogin
      ? checks?.checksList?.reduce((acc, checkTask) => {
          acc[checkTask._id] = true;
          return acc;
        }, {})
      : {};

  const checksAll = [
    ...(syncCheckCache?.map((check) => ({
      ...check,
      status: 'Synced',
      type: 'Check',
      id: check?.checkNumber || null,
      _id: check?.checkNumber || null
    })) || []),

    ...(checkCache?.map((check) => ({
      ...check,
      status: 'To do',
      type: 'Check',
      id: uuidv4() || null,
      _id: check?.id || uuidv4()
    })) || [])
  ];

  let newSyncedChecks = [];
  if (!_.isEmpty(allChecksMap)) {
    newSyncedChecks = checksAll.map((check) => {
      if (!allChecksMap[check._id]) {
        return {
          syncDateCustom: moment().format('YYYY-MM-DD'),
          ...check
        };
      } else return check;
    });
  } else newSyncedChecks = checksAll;

  let checkAll = [
    ...checks.checksList.filter((t) => t.status === 'Pending sync' || t.status === 'In progress')
  ];

  (newSyncedChecks || []).map((task) => {
    const found = checkAll.findIndex((t) => t._id === task._id || t.id === task.id) + 1;
    if (found) {
      if (!['In progress', 'Pending sync'].includes(checkAll[found - 1].status)) {
        checkAll[found - 1] = { ...task };
      }
    } else {
      checkAll.push({ ...task });
    }
  });

  return {
    checksList: checkAll
  };

  // return newSyncedChecks;
};

export { assignedAndSyncedChecksManipulationJson };
